import { useSelector } from "react-redux";

import { Box, Grid } from "@material-ui/core";

import { BreakDownBySource } from "./BreakDownBySource";
import { UnrealizedRevenuesPie } from "./UnrealizedRevenuesPie";
import { UnrealizedRevenuesBarChart } from "./UnrealizedRevenuesBarChart";
import { ActionTimeGroup } from "../../../../components/actionTimeTimeGroup";

export const UnrealizedRevenuesTab = () => {
  const { period, startDate, endDate } = useSelector((state) => state.selectedPeriods);

  return (
    <Box>
      <ActionTimeGroup />

      <Grid container spacing={4}>
        <UnrealizedRevenuesPie period={period} startDate={startDate} endDate={endDate} />

        <UnrealizedRevenuesBarChart period={period} startDate={startDate} endDate={endDate} />
      </Grid>

      <BreakDownBySource />
    </Box>
  );
};
